<template>
    <div>
      <el-card v-loading="loading" class="box">
        <div class="head">
          <el-input
          v-model="input"
          size="mini"
          style="width: 110px; margin-right: 10px"
          placeholder="请输入">
          </el-input>
          <el-button type="primary" size="mini" @click="search" icon="el-icon-search">搜索</el-button>
          <el-button type="success" size="mini" @click="export_" icon="el-icon-download">导出数据</el-button>
          <el-button type="success" size="mini" @click="operate">批量操作</el-button>
          <el-button type="success" size="mini" @click="plss" style="margin-right:200px">批量搜索</el-button>
          <!-- <div class="block">
            <el-date-picker
              size="mini"
              style="width:200px;margin-right:200px"
              @change="block"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div> -->

          <!-- 请选择站点 -->
          <el-select size="mini" v-model="selectSite" multiple placeholder="请选择站点">
            <el-option
              v-for="item in Site"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择订单状态 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectListStatus" multiple placeholder="请选择订单状态">
            <el-option
              v-for="item in ListStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择商品状态 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectProductStatus" multiple placeholder="请选择商品状态">
            <el-option
              v-for="item in ProductStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择物流商 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectWLS" multiple placeholder="请选择物流商">
            <el-option
              v-for="item in WLS"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="CXDD" style="margin-left: 10px">查询订单</el-button>

        </div>
          <el-table
            height="690"
            :data="tableData"
            border
            style="width: 100%;border: 1px solid #000000"
            :row-style="{height:'100px'}"
            :cell-style="{padding:0,borderColor:'#000000'}"
            :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
            @selection-change="selectionChange"
            :default-sort = "{prop: 'date_created_gmt', order: 'descending'}"
            @cell-dblclick='DblclickCell'
          >

            <!-- :row-class-name="RowNumber" -->
            <!-- 全选按钮 -->
            <el-table-column
              align="center"
              type="selection"
              label="全选"
              width="40px">
            </el-table-column>
            
            <!-- 站点 -->
            <!-- :filter-method="filter"
            :filters="[{ text: 'madrid-shop', value: 'madrid-shop' }, { text: 'cuirz', value: 'cuirz' }, { text: 'nihonbro', value: 'nihonbro' }, { text: 'jleague-shop', value: 'jleague-shop' }, { text: 'supermaillot', value: 'supermaillot' }, { text: 'fortmaillot', value: 'fortmaillot' }, { text: 'kickitshirts', value: 'kickitshirts' }, { text: 'mailloten', value: 'mailloten' }, { text: 'honorjersey', value: 'honorjersey' }, { text: 'ligafoot', value: 'ligafoot' }, { text: 'beazl', value: 'beazl' }, { text: 'top-w', value: 'top-w' }]" -->
            <!-- prop="tag" -->
            <!-- <el-table-column
            width="110px"
            label="站点">
              <template slot-scope="scope">
                <div>{{scope.row.site}}</div>
              </template>
            </el-table-column> -->

            <!-- 订单状态 -->
            <!-- :filtered-value = "['正在处理']"
            :filters="[{ text: '待付款', value: '待付款' }, { text: '正在处理', value: '正在处理' }, { text: '保留', value: '保留' }, { text: '已完成', value: '已完成' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '失败订单', value: '失败订单' }]"
            :filter-method="filterTag" -->
            <el-table-column
              width="90px"
              prop="status"
              label="订单状态"
              align="center"
              >
              <template slot-scope="scope">
                <el-tag
                :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
                disable-transitions>
                  {{scope.row.status}}
                </el-tag>
              </template>
            </el-table-column>

            <!-- 订单ID -->
            <el-table-column prop="ID_" label="订单ID" width="60px" align="center">
            </el-table-column>

            <!-- 商品ID -->
            <el-table-column prop="product_id" label="商品ID" width="140px" align="center">
            </el-table-column>

            <!-- 下单时间 -->
            <el-table-column prop="date_created_gmt" label="下单时间" sortable width="95px" align="center">
            </el-table-column>
            
            <!-- 付款时间 -->
            <el-table-column prop="date_paid_gmt" label="付款时间" sortable width="95px" align="center">
            </el-table-column>

            <!-- SKU -->
            <!-- <el-table-column prop="sku" label="SKU" width="100px">
            </el-table-column> -->

            <!-- 国际物流单号 -->
            <el-table-column prop="int_no" label="国际物流单号" width="140px" align="center">
            </el-table-column>

            <!-- 图片 -->
            <el-table-column label="图片" width="50px" align="center">
              <template slot-scope="scope">
                <el-popover placement="right" width="500" trigger="click">
                  <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
                  <img :src="scope.row.img" alt="暂无图片" width="30px" height="30px" slot="reference">
                </el-popover>
              </template>
            </el-table-column>
            <!-- <el-table-column label="图片" width="120px">
              <template slot-scope="scope">
                <img :src="scope.row.img" alt="暂无图片" width="100px" >
              </template>
            </el-table-column> -->

            <!-- 商品名称 -->
            <el-table-column prop="product_name" label="商品名称" width="140px" align="center">
            </el-table-column>

            <!-- 定制信息 -->
            <el-table-column label="定制信息" align="center">
              <template slot-scope="scope"> 
                <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
                <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
                <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
                <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
              </template>
            </el-table-column>

            <!-- 袖标 -->
            <el-table-column label="袖标" width="125" align="center">
              <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
                <span v-for="(item,index) in scope.row.armband" :key="index">
                    <el-popover placement="left" trigger="click" width="300">
                      <img :src="item" width="100%" style="background:gray" />
                      <img
                        slot="reference"
                        :src="item"
                        :alt="123"
                        width="48px" height="48px"
                        style="margin:1px;background:gray"
                      />
                    </el-popover>
                  </span>
              </template>
            </el-table-column>

            <!-- 配件 -->
            <el-table-column label="配件" width="125" align="center">
              <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
                <span v-for="(item,index) in scope.row.accessories" :key="index">
                    <el-popover placement="left" trigger="click" width="300">
                      <img :src="item" width="100%" />
                      <img
                        slot="reference"
                        :src="item"
                        :alt="123"
                        width="50px" height="50px"
                      />
                    </el-popover>
                  </span>
              </template>
            </el-table-column>

            <!-- 数量 -->
            <el-table-column prop="quantity" label="数量" width="40px" align="center">
            </el-table-column>

            <!-- 采购价 -->
            <el-table-column label="采购价" width="70px" align="center">
              <template slot-scope="scope">
                <span v-if='!scope.row.edit'>{{scope.row.cgj}}</span>
                <el-input size='mini' type='number' ref="CGJ" v-else v-model="scope.row.cgj" @blur='HandleBlur(scope.row)'>{{scope.row.cgj}}</el-input>
              </template>
            </el-table-column>

            <!-- 客户备注 -->
            <el-table-column prop="customer_note" label="客户备注" align="center">
            </el-table-column>

            <!-- 商品备注 -->
            <el-table-column label="商品备注" width="100px" align="center">
              <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                  <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 商品状态 -->
            <!-- :filter-method="filterproduct"
            :filters="[{ text: '待审核', value: '待审核' }, { text: '待发货-制作中', value: '待发货-制作中' }, { text: '待发货', value: '待发货' }, { text: '仓库已发货', value: '仓库已发货' }, { text: '已到货代', value: '已到货代' }, { text: '物流已发货', value: '物流已发货' }, { text: '异常', value: '异常' }, { text: '暂停', value: '暂停' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '缺货', value: '缺货' }]" -->
            <el-table-column prop="product_status" label="商品状态" width="130px" align="center">
              <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
                  <el-button
                   :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '仓库已发货' ? 'warning' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : (scope.row.product_status === '缺货' ? 'info' : '')))))))))))" 
                   size="mini">
                      {{scope.row.product_status}}
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- 物流方式 -->
            <el-table-column prop="shiptype" label="物流方式" width="60px" align="center">
            </el-table-column>

            <!-- 物流商 -->
            <!-- :filter-method="filterWlS" 
            :filters="[{text:'ST', value:'ST'},{text:'V20', value:'V20'},{text:'66', value:'66'},{text:'WSY', value:'WSY'}]" -->
            <el-table-column prop="wls" label="物流商" width="50px" align="center">
            </el-table-column>

            <!-- 是否加急 -->
            <el-table-column align="center" :filters="[{text:'是',value:'是'},{text:'否',value:'否'}]" :filter-method="filterHandler" prop='isurgent' label="是否加急" width="55">
              <template slot-scope="scope">
                <span >{{scope.row.isurgent}}</span>
              </template>
            </el-table-column>

            <!-- 操作 编辑 -->
            <el-table-column label="操作" width="50px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="edit(scope.$index, scope.row)"
                  circle
                >
                </el-button>
                <el-button
                  style="margin-left: 0;margin-top: 10px;"
                  type="primary"
                  size="mini"
                  icon="el-icon-view"
                  @click="look(scope.$index, scope.row)"
                  circle
                >
                </el-button>
              </template>
            </el-table-column>

          </el-table>

          <!-- 商品信息弹出框 -->
          <el-dialog title="商品信息" :visible.sync="dialogFormVisible">
            <el-form :model="form">
              <el-form-item label="商品ID" :label-width="formLabelWidth">
                <el-input v-model="form.product_id" autocomplete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="商品名称" :label-width="formLabelWidth">
                <el-input v-model="form.product_name" autocomplete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="客服备注" :label-width="formLabelWidth">
                <el-input v-model="form.product_note" autocomplete="off" placeholder="请输入客服备注" disabled></el-input>
              </el-form-item>
              <el-form-item label="仓库备注" :label-width="formLabelWidth">
                <el-input v-model="form.warehouse_note" autocomplete="off" placeholder="请输入仓库备注"></el-input>
              </el-form-item>
              <el-form-item label="物流备注" :label-width="formLabelWidth">
                <el-input v-model="form.logistics_note" autocomplete="off" placeholder="请输入物流备注" disabled></el-input>
              </el-form-item>
              <el-form-item label="国内快递单号" :label-width="formLabelWidth">
                <el-input :disabled="form.product_status == '仓库已发货' ? false : true" v-model="form.inland_number" autocomplete="off" placeholder="请输入国内快递单号"></el-input>
              </el-form-item>
              <el-form-item label="商品状态" :label-width="formLabelWidth">
                <el-select v-model="form.product_status" placeholder="请选择商品状态">
                  <el-option label="待审核" value="待审核" disabled></el-option>
                  <el-option label="待发货" value="待发货" disabled></el-option>
                  <el-option label="待发货-制作中" value="待发货-制作中" disabled></el-option>
                  <el-option label="待处理" value="待处理"></el-option>
                  <el-option label="仓库已发货" value="仓库已发货"></el-option>
                  <el-option label="已到货代" value="已到货代" disabled></el-option>
                  <el-option label="物流已发货" value="物流已发货" disabled></el-option>
                  <el-option label="异常" value="异常" disabled></el-option>
                  <el-option label="暂停" value="暂停"></el-option>
                  <el-option label="已取消" value="已取消" disabled></el-option>
                  <el-option label="已退款" value="已退款" disabled></el-option>
                  <el-option label="缺货" value="缺货"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel">取 消</el-button>
              <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
          </el-dialog>

          <!-- 导出数据二次确认框 -->
          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>您确认要导出选中的数据吗?</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleUpload">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 批量操作弹出框 -->
          <el-dialog title="商品详情" :visible.sync="dialog_">
            <el-form :model="form_">
              <el-form-item label="商品id" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  :rows="10"
                  placeholder="请输入商品id"
                  v-model="form_.textarea"
                  show-word-limit
                  maxlength="999999999999999">
                </el-input>
              </el-form-item>
              <el-form-item label="国内快递单号" :label-width="formLabelWidth">
                <el-input v-model="form_.inland_number" autocomplete="off"></el-input>
              </el-form-item>
              <!-- <el-form-item label="商品状态" :label-width="formLabelWidth">
                <el-select v-model="form_.product_status" placeholder="请选择商品状态">
                  <el-option label="待审核" value="待审核" disabled></el-option>
                  <el-option label="待发货" value="待发货" disabled></el-option>
                  <el-option label="待发货-制作中" value="待发货-制作中" disabled></el-option>
                  <el-option label="仓库已发货" value="仓库已发货"></el-option>
                  <el-option label="已到货代" value="已到货代" disabled></el-option>
                  <el-option label="物流已发货" value="物流已发货" disabled></el-option>
                  <el-option label="异常" value="异常"></el-option>
                  <el-option label="暂停" value="暂停"></el-option>
                  <el-option label="已取消" value="已取消" disabled></el-option>
                  <el-option label="已退款" value="已退款" disabled></el-option>
                  <el-option label="缺货" value="缺货"></el-option>
                </el-select>
              </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialog_ = false">取 消</el-button>
              <el-button type="primary" @click="QD">确 定</el-button>
            </div>
          </el-dialog>

          <!-- 批量搜索对话框 -->
          <el-dialog
            title="商品id和(或者)订单id"
            :visible.sync="plss_"
            width="50%">
            <el-input type="textarea" :rows="10" placeholder="请输入商品id和(或者)订单id" v-model="abc" show-word-limit maxlength="999999999999999"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="plss_ = false">取 消</el-button>
              <el-button type="primary" @click="qdplss">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 批量采购对话框 -->
          <el-dialog
            title="批量采购"
            :visible.sync="plcg"
            width="50%">
            <el-input type="textarea" :rows="10" placeholder="请输入商品id和对应采购价格" v-model="cgjg" show-word-limit maxlength="999999999999999"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="plcg = false">取 消</el-button>
              <el-button type="primary" @click="qdcg">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 分页器 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pss"
            :page-size="ps"
            :total="Total"
            layout="total, sizes, prev, pager, next, jumper"
            style="display:flex; justify-content: center;">
          </el-pagination>

      </el-card>



    </div>
</template>

<script>
import { getProduct,Edit,DC,Batch,getProductList,getProductPage,czjl,ckpllrspcgj } from '../../api/api'
import table2excel from 'js-table2excel'
import imageToBase64 from 'image-to-base64/browser';
export default {
    // inject: ['reload'],
    data() {
      return {

        upCgj:[],
        cgjg:'',
        plcg:false,

        abc:'',
        plss_:false,

        currentPage: 1,//默认第几页
        pss:[50,100,200,500,700,1000],
        ps:100,//默认每页条数
        Total:0,

        Site:[{ label: 'madrid-shop', value: 'madrid-shop' }, { label: 'cuirz', value: 'cuirz' }, { label: 'nihonbro', value: 'nihonbro' }, { label: 'jleague-shop', value: 'jleague-shop' }, { label: 'supermaillot', value: 'supermaillot' }, { label: 'fortmaillot', value: 'fortmaillot' }, { label: 'kickitshirts', value: 'kickitshirts' }, { label: 'mailloten', value: 'mailloten' }, { label: 'honorjersey', value: 'honorjersey' }, { label: 'ligafoot', value: 'ligafoot' }, { label: 'beazl', value: 'beazl' }, { label: 'top-w', value: 'top-w' }],
        selectSite:[],//筛选站点
        ListStatus:[{ label: '待付款', value: '待付款' }, { label: '正在处理', value: '正在处理' }, { label: '保留', value: '保留' }, { label: '已完成', value: '已完成' }, { label: '已取消', value: '已取消' }, { label: '已退款', value: '已退款' }, { label: '失败订单', value: '失败订单' }],
        selectListStatus:['正在处理'],//筛选订单状态
        ProductStatus:[{ text: '待审核', value: '待审核' }, { text: '待发货', value: '待发货' }, { text: '待发货-制作中', value: '待发货-制作中' }, { text: '待处理', value: '待处理' }, { text: '仓库已发货', value: '仓库已发货' }, { text: '已到货代', value: '已到货代' }, { text: '物流已发货', value: '物流已发货' }, { text: '异常', value: '异常' }, { text: '暂停', value: '暂停' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '缺货', value: '缺货' }],//商品状态
        selectProductStatus:[],//筛选商品状态
        WLS:[{text:'ST', value:'ST'},{text:'V20', value:'V20'},{text:'66', value:'66'},{text:'WSY', value:'WSY'},{text:'HB', value:'HB'}],//物流商
        selectWLS:[],//筛选物流商

        dialogVisible:false,
        dialogFormVisible: false,
        dialog_: false,
        form: {
          product_id: '',
          product_name: '',
          product_note: '',
          warehouse_note: '',
          logistics_note: '',
          inland_number: '',
          product_status: ''
        },
        form_:{
          textarea:'',
          inland_number:'',
          product_id:[],
          time:'',
          person:'ck'
        },
        formLabelWidth: '120px',
        tableData: [],//页面展示
        loading: true,
        Data_: [],//导出数据
        input: "",
        value1:[],
      }
    },

    created () {

      var params = {
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:[]
      }
      getProductPage(params).then(res => {
        this.Total = res.length;
      })

      var params = {
        Limit:this.ps,
        Offset:0,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:[]
      }
      getProductList(params).then(res => {
        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }

          if(i.edit == undefined){
            i.edit = false;
          }
        }
        
        this.tableData = res;
        this.loading = false;
      })

    },
    
    methods: {

      // 筛选是否加急
      filterHandler(value, row) {
        if(value === '否'){
          return row.isurgent === '';
        }else{
          return row.isurgent === value;
        }
      },

      // 双击单元格显示input输入框
      // DblclickCell(row, column, cell, event){
      DblclickCell(row){
        this.$set(row,'edit',true);
        // input输入框自动获取焦点
        this.$nextTick(() => {
          this.$refs.CGJ.focus();
        })
      },

      // input输入框失去焦点
      HandleBlur(row){
        this.$set(row,'edit',false);
        this.upCgj = {
          cgj:row.cgj,
          product_id:row.product_id
        }
        if(row.cgj == ''){
          this.$message({
            message:'采购价为空,请先输入采购价',
            type:'warning'
          })
          return false
        }
        ckpllrspcgj(this.upCgj).then(res => {
          if(res.code == 200){
            this.$message({
              message:res.msg,
              type:'success'
            })
          }else if(res.code == 404){
            this.$message({
              message:res.msg,
              type:'warning'
            })
          }
        })
      },

      // 筛选采购价
      filternote(value,row){
        if(value == '未报价'){
          return row.cgj === '无';
        }else{
          return row.cgj != value && row.cgj != '无';
        }
      },

      // 批量采购
      plBuy(){
        this.plcg = true;
        this.cgjg = '';
      },

      // 删除数组中的空字符串
      delNull(s){
        return (s && s.trim());
      },

      // 过滤商品id
      fn1(A){
        return A.substr(-1).charCodeAt() >= 97 && A.substr(-1).charCodeAt() <= 122;
      },

      // 过滤采购价
      fn2(B){
        return B.substr(-1).charCodeAt() >= 48 && B.substr(-1).charCodeAt() <= 58;
      },

      // 确定批量采购
      qdcg(){
        this.loading = true;

        if(this.cgjg == '' || this.cgjg == null || this.cgjg == undefined){
          this.loading = false;
          this.$message({
            message:'采购内容为空!!!',
            type:'warning'
          })
          this.plcg = false;
          return false;
        }

        var jiu = [];
        jiu = this.cgjg.replace(/\n/g,',').replace(/\s+/g,'').replace(/madrid-shop/g,'madrid-shop,').replace(/cuirz/g,'cuirz,').replace(/nihonbro/g,'nihonbro,').replace(/jleague-shop/g,'jleague-shop,').replace(/supermaillot/g,'supermaillot,').replace(/fortmaillot/g,'fortmaillot,').replace(/kickitshirts/g,'kickitshirts,').replace(/mailloten/g,'mailloten,').replace(/honorjersey/g,'honorjersey,').replace(/ligafoot/g,'ligafoot,').replace(/beazl/g,'beazl,').replace(/top-w/g,'top-w,').split(',').filter(this.delNull);
        console.log(jiu);

        // 判断录入的数据是否是一一对应，必须长度为偶数
        if(jiu.length % 2 != 0){
          this.loading = false;
          this.$message({
            message:'数据错误,检查无误后录入',
            type:'warning'
          })
          this.plcg = false;
          return false
        }

        for(var i = 0;i < jiu.length;i++){

          // 判断录入的数据奇数个的时候必须是商品id
          if(i % 2 == 0 && (jiu[i].substr(-1).charCodeAt() < 97 || jiu[i].substr(-1).charCodeAt() > 122)){
            this.loading = false;
            this.$message({
              message:'数据错误,检查无误后录入',
              type:'warning'
            })
            this.plcg = false;
            return false
          }
          
          // 判断录入的数据偶数个的时候必须是采购价
          else if(i % 2 == 1 && (jiu[i].substr(-1).charCodeAt() < 48 || jiu[i].substr(-1).charCodeAt() > 58)){
            this.loading = false;
            this.$message({
              message:'数据错误,检查无误后录入',
              type:'warning'
            })
            this.plcg = false;
            return false
          }

        }

        var _a = jiu.filter(this.fn1)
        var _b = jiu.filter(this.fn2)

        // 格式化录入的数据为[{key1:value1,key2:value2},{}...]
        _a.forEach((item,index) => {
          this.upCgj.push({
            product_id:item,
            cgj:_b[index]
          })
        })

        console.log(this.upCgj);
        ckpllrspcgj(this.upCgj).then(res => {
          if(res.code == 200){
            for(var i of this.tableData){
              for(var k of this.upCgj){
                if(i.product_id == k.product_id){
                  i.cgj = k.cgj;
                }
              }
            }
            this.plcg = false;
            this.loading = false;
            this.$message({
              message:res.msg,
              type:'success'
            })
          }else if(res.code == 404){
            this.plcg = false;
            this.loading = false;
            this.$message({
              message:res.msg,
              type:'warning'
            })
          }
        })

      },

      // 批量搜索
      plss(){
        this.plss_ = true;
      },

      // 确定批量搜索
      qdplss(){
        this.plss_ = false;
        // console.log(this.abc,typeof(this.abc));
        if(this.abc == '' || this.abc == null || this.abc == undefined){
          this.$message({
            message:'搜索内容为空!!!',
            type:'warning'
          })
          return false;
        }
        // var a = this.abc.replace(/madrid-shop/g,'madrid-shop,').replace(/cuirz/g,'cuirz,').replace(/nihonbro/g,'nihonbro,').replace(/jleague-shop/g,'jleague-shop,').replace(/supermaillot/g,'supermaillot,').replace(/fortmaillot/g,'fortmaillot,').replace(/kickitshirts/g,'kickitshirts,').replace(/mailloten/g,'mailloten,').replace(/honorjersey/g,'honorjersey,').replace(/ligafoot/g,'ligafoot,').replace(/beazl/g,'beazl,').replace(/top-w/g,'top-w,');
        var a = this.abc.replace(/\n/g,',');
        // console.log(a);
        const Plss = this.$router.resolve({ path: "/home/search_", query: { product_id: a}});
        window.open(Plss.href, '_blank');
        
      },

      //设置每页几条
      handleSizeChange(val) {
        this.loading = true;
        this.ps = val;
        var limit = val;
        var offset = (this.currentPage - 1) * val;
        var params = {
          Limit:limit,
          Offset:offset,
          Site:this.selectSite,
          ListStatus:this.selectListStatus,
          ProductStatus:this.selectProductStatus,
          WLS:this.selectWLS,
          date_created_gmt:[]
        }
        getProductList(params).then(res => {
          for (const i of res) {
            if(i.armband == null || i.armband == undefined || i.armband == ''){
              i.armband = '无';
            }
            else if(i.armband.charAt(0) == "h"){
              i.armband = i.armband.split(",");
            }

            if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
              i.accessories = '无';
            }
            else if(i.accessories.charAt(0) == "h"){
              i.accessories = i.accessories.split(",");
            }
          }
          this.tableData = res;
          this.loading = false;
        })
      },

      //前往第几页
      handleCurrentChange(val) {
        this.loading = true;
        this.currentPage = val;
        var limit = this.ps;
        var offset = (val - 1) * this.ps;
        var params = {
          Limit:limit,
          Offset:offset,
          Site:this.selectSite,
          ListStatus:this.selectListStatus,
          ProductStatus:this.selectProductStatus,
          WLS:this.selectWLS,
          date_created_gmt:[]
        }
        getProductList(params).then(res => {
          for (const i of res) {
            if(i.armband == null || i.armband == undefined || i.armband == ''){
              i.armband = '无';
            }
            else if(i.armband.charAt(0) == "h"){
              i.armband = i.armband.split(",");
            }

            if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
              i.accessories = '无';
            }
            else if(i.accessories.charAt(0) == "h"){
              i.accessories = i.accessories.split(",");
            }
          }
          this.tableData = res;
          this.loading = false;
        })
      },

      // 查询订单
      CXDD(){
        this.loading = true;
        var params = {
          Limit:this.ps,
          Offset:(this.currentPage - 1) * this.ps,
          Site:this.selectSite,
          ListStatus:this.selectListStatus,
          ProductStatus:this.selectProductStatus,
          WLS:this.selectWLS,
          date_created_gmt:[]
        }
        getProductList(params).then(res => {
          // console.log(res);
          for (const i of res) {
            if(i.armband == null || i.armband == undefined || i.armband == ''){
              i.armband = '无';
            }
            else if(i.armband.charAt(0) == "h"){
              i.armband = i.armband.split(",");
            }

            if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
              i.accessories = '无';
            }
            else if(i.accessories.charAt(0) == "h"){
              i.accessories = i.accessories.split(",");
            }
          }
            // if(i.armband == null || i.armband == ""){
            //   i.armband = "无";
            // }
            // if(i.accessories == null || i.accessories == ""){
            //   i.accessories = "无";
            // }
            // if(i.word_no == null || i.word_no == "" || i.word_no == "null"){
            //   i.word_no = "无";
            // }
            // i.pro_det = `<br/>配件:${i.accessories}<br/>字号:${i.word_no}<br/>尺码:${i.size}<br/>袖标:${i.armband}`;
          
          this.tableData = res;
          this.loading = false;
        })
        var params = {
          Site:this.selectSite,
          ListStatus:this.selectListStatus,
          ProductStatus:this.selectProductStatus,
          WLS:this.selectWLS,
          date_created_gmt:[]
        }
        getProductPage(params).then(res => {
          this.Total = res.length;
        })
      },

      //批量操作
      operate(){
        // if(this.Data_.length == 0){
        //   this.$message({
        //     message:'请先选择要操作的商品！！！',
        //     type:'warning'
        //   })
        // }else{
          this.dialog_ = true;
        // }
      },
      
      //确定(批量操作)
      QD(){
        if(this.form_.textarea == '' || this.form_.inland_number == ''){
          this.$message({
            message:'表单信息填写不完整!!!',
            type:'warning'
          })
          this.dialog_ = false;
          return false;
        }
        var a = this.form_.textarea.replace(/madrid-shop/g,'madrid-shop,').replace(/cuirz/g,'cuirz,').replace(/nihonbro/g,'nihonbro,').replace(/jleague-shop/g,'jleague-shop,').replace(/supermaillot/g,'supermaillot,').replace(/fortmaillot/g,'fortmaillot,').replace(/kickitshirts/g,'kickitshirts,').replace(/mailloten/g,'mailloten,').replace(/honorjersey/g,'honorjersey,').replace(/ligafoot/g,'ligafoot,').replace(/beazl/g,'beazl,').replace(/top-w/g,'top-w,');
        var b = a.split(',');
        var uu = [];
        for(var i = 0;i < b.length;i++){
          var c = b[i].replace('\n','');
          uu.push(c);
        }
        uu.pop();
        // console.log(uu);
        //查所有商品信息 循环uu改 国内快递单号 和 商品状态 this.form_传到后端改数据库.

        for(var j of this.tableData){
          for(var k of uu){
            if(j.product_id == k && j.product_status != '待发货-制作中'){
              // this.$message({
              //   message:'您填写的商品id里存在商品状态错误的商品,请核对后再编辑国内快递单号',
              //   type:'error'
              // })
              // this.dialog_ = false;
              continue;
            }else if(j.product_id == k && j.product_status == '待发货-制作中'){
              j.inland_number = this.form_.inland_number;
              j.product_status = '仓库已发货';
            }
          }
        }
        // for(var t of this.Data_){
        //   if(t.product_status == '仓库已发货'){
        //     this.$message({
        //       message:'您选中的商品中存在仓库已发货的商品,不能将国内快递单号设置为空！！！',
        //       type:'warning'
        //     })
        //     this.dialog_ = false;
        //     return false;
        //   }
        // }
        // for(var i of this.tableData){
        //   for(var k of this.Data_){
        //     if(this.form_.inland_number == '' || this.form_.inland_number == null || this.form_.inland_number == undefined){
        //       this.$message({
        //         message:'国内快递单号不能为空！！！',
        //         type:'warning'
        //       })
        //       this.dialog_ = false;
        //       return false;
        //     }else if(i.product_id == k.product_id && k.product_status != '仓库已发货'){
        //       i.inland_number = this.form_.inland_number;
        //       i.product_status = '仓库已发货';
        //       this.form_.product_status = '仓库已发货';
        //       this.form_.product_id.push(k.product_id);
        //     }
        //   }
        // }
        this.form_.product_id = uu;
        var timee = new Date();
        var timeee = this.$moment(timee.getTime()).format("YYYY-MM-DD HH:mm:ss");
        this.form_.time = timeee;
        var params = this.form_;
        // console.log(params);
        Batch(params).then(res => {});
        this.$message({
          message:'编辑成功！！！',
          type:'success'
        })
        this.dialog_ = false;
        var t = new Date();
        var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss");
        var lll = params.textarea.split('\n').length;
        var cf = params.textarea.split('\n').toString();
        var n = params.inland_number;
        var post = {
          person:'ck',
          time:time_,
          event:'将' + cf + '共' + lll + '件商品的国内快递单号批量编辑为' + n + '。'
        };
        // console.log(post);
        czjl(post).then(res => {});
      },

      // X(导出数据)
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },

      //导出数据(二次确认)
      export_(){
        this.dialogVisible = true;
      },

      //导出数据(确认导出)
      handleUpload(){
        this.dialogVisible = false;
        if(this.Data_.length == 0){
          this.$message({
            message: "导出数据为空,请先选中您要导出的数据",
            type: "warning",
            showClose: true
          })
          return false;
        }else{
          for(var i = 0;i < this.Data_.length;i++){
            this.Data_[i].date_paid_gmt = this.$moment(this.Data_[i].date_paid_gmt).format('YY-MM-DD');
          }
        }

        const column = [
          {
            title: '商品id',
            key: 'product_id',
            type: 'text'
          },
          {
            title: '订单id', 
            key: 'ID_',
            type: 'text'
          },
          {
            title: '支付时间', 
            key: 'date_paid_gmt',
            type: 'text'
          },
          {
            title: '产品图片',
            key: 'img',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '产品名称',
            key: 'product_name',
            type: 'text'
          },
          {
            title: '数量',
            key: 'quantity',
            type: 'text'
          },
          {
            title: '配件1',
            key: 'accessories1',
            type: 'image',
            width: 40,
            height: 40
          },
          {
            title: '配件2',
            key: 'accessories2',
            type: 'image',
            width: 40,
            height: 40
          },
          {
            title: '定制信息',
            key: 'pro_det',
            type: 'text'
          },
          {
            title: '袖标1',
            key: 'armband1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标2',
            key: 'armband2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标3',
            key: 'armband3',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标4',
            key: 'armband4',
            type: 'image',
            width: 80,
            height: 80
          },
          // {
          //   title: '袖标5',
          //   key: 'armband5',
          //   type: 'image',
          //   width: 80,
          //   height: 80
          // },
          // {
          //   title: '袖标6',
          //   key: 'armband6',
          //   type: 'image',
          //   width: 80,
          //   height: 80
          // },
          
          // {
          //   title: '客户备注',
          //   key: 'customer_note',
          //   type: 'text'
          // },
          
          {
            title: '物流商',
            key: 'wls',
            type: 'text'
          },
          // {
          //   title: '客服备注',
          //   key: 'product_note',
          //   type: 'text',
          //   width: 120
          // },
          {
            title: '仓库备注',
            key: 'warehouse_note',
            type: 'text',
          },
          {
            title: '是否加急',
            key: 'isurgent',
            type: 'text',
          },
          // {
          //   title: '商品状态',
          //   key: 'product_status',
          //   type: 'text'
          // },
          // {
          //   title: '国际物流单号',
          //   key: 'int_no',
          //   type: 'text'
          // }
        ]

        
        table2excel(column, this.Data_, "订单列表.xls");
        var abc = [];
        for(var i of this.Data_){
          if(i.product_status == "待发货" || i.product_status == "异常" || i.product_status == "缺货"){
            i.product_status = "待发货-制作中";
            abc.push(i.product_id);
          }
        }
        var params = {
          "product_id":abc,
          "product_status":"待发货-制作中"
        };
        DC(params).then(res => {});

        var t = new Date();
        var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss");
        var lll = this.Data_.length;
        var abc = [];
        for(var i of this.Data_){
          abc.push(i.product_id);
        }
        var nba = abc.toString();
        var params_ = {
          person:'ck',
          time:time_,
          event:'导出了' + nba + '共' + lll + '件商品。'
        }
        czjl(params_).then(res => {});

      },

      //编辑
      edit(index,row){
        this.dialogFormVisible = true;
        this.form = {
          product_id: row.product_id,
          product_name: row.product_name,
          product_note: row.product_note,
          warehouse_note: row.warehouse_note,
          logistics_note: row.logistics_note,
          inland_number: row.inland_number,
          product_status: row.product_status
        }
      },

      //取消编辑
      cancel(){
        this.dialogFormVisible = false;
        this.$message('取消编辑成功！！！');
      },

      //确定编辑
      confirm(){
        // console.log(this.form.inland_number);
        if((this.form.inland_number == '' || this.form.inland_number == undefined) && this.form.product_status == "仓库已发货"){
          this.$message({
            message:'仓库已发货时，国内快递单号不能为空！！！',
            type:'error'
          })
          return false;
        }else{
          var timee = new Date();
          var timeee = this.$moment(timee.getTime()).format("YYYY-MM-DD HH:mm:ss");
          var params = {
            product_id: this.form.product_id,
            product_name: this.form.product_name,
            product_note:this.form.product_note,
            warehouse_note:this.form.warehouse_note,
            logistics_note:this.form.logistics_note,
            inland_number:this.form.inland_number,
            product_status:this.form.product_status,
            person:'ck',
            time:timeee
          };
          Edit(params).then(res => {
            if(res.code === 200){
              this.loading = true;
              for(var i of this.tableData){
                if(i.product_id == this.form.product_id){
                  i.product_name = this.form.product_name;
                  i.product_note = this.form.product_note;
                  i.warehouse_note = this.form.warehouse_note;
                  i.logistics_note = this.form.logistics_note;
                  i.inland_number = this.form.inland_number;
                  i.product_status = this.form.product_status;
                }
              }
              this.loading = false;
              this.$message({
                message: '编辑成功！！！',
                type: 'success'
              });
            }else{
              this.$message({
                message: '编辑失败！！！',
                type: 'error'
              });
            }
          }).catch((error) => {
            console.log(error);
          });
          this.dialogFormVisible = false;
        }
        // // this.reload();
      },

      //查看详情
      look(index, row){
        const routeData = this.$router.resolve({ path: "/home/Orderdetail_A", query: { site: row.site, ID_: row.ID_ } });
        window.open(routeData.href, '_blank');
      },

      //复选框
      selectionChange(selection){
        for(var k = 0;k < selection.length;k++){
          // if(selection[k].pro_det == undefined){
          //   selection[k].pro_det = `<br/>配件:${selection[k].accessories}<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:${selection[k].armband}`;
          // }
          // if(selection[k].customer_note == null){
          //   selection[k].customer_note = '无';
          // }

          // 定制信息
          if(selection[k].pro_det == undefined){
            // var pj = "配件:",zh = "字号:",cm = "尺码:",xb = "袖标:";
            var zh = "字号:",cm = "尺码:";
            // pj = pj.fontcolor('red');
            // pj = pj.fontsize(3);
            // pj = pj.bold();
            zh = zh.fontcolor('#00ff00');
            zh = zh.fontsize(3);
            zh = zh.bold();
            cm = cm.fontcolor('blue');
            cm = cm.fontsize(3);
            cm = cm.bold();
            // xb = xb.fontcolor('cyan');
            // xb = xb.fontsize(3);
            // xb = xb.bold();
            // selection[k].pro_det = '<br/>配件:' + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + `<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:` + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
            // selection[k].pro_det = pj + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + zh + `${selection[k].word_no}` + cm + `${selection[k].size}` + xb + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
            selection[k].pro_det = zh + `${selection[k].word_no}` + cm + `${selection[k].size}`;
          }

          // 格式化支付时间
          // selection[k].date_paid_gmt = this.$moment(selection[k].date_paid_gmt).format('YY-MM-DD');

          // 整合袖标图片
          if(typeof(selection[k].armband) == 'object'){
            // 将袖标字符串转化为数组
            var ddd = selection[k].armband;
            // 袖标数组长度
            var ttt = selection[k].armband.length;
            if(ttt == 0){
              if(selection[k].armband1 == undefined){
                selection[k].armband1 = '无';
              }
              if(selection[k].armband2 == undefined){
                selection[k].armband2 = "无";
              }
              if(selection[k].armband3 == undefined){
                selection[k].armband3 = "无";
              }
              if(selection[k].armband4 == undefined){
                selection[k].armband4 = "无";
              }
              if(selection[k].armband5 == undefined){
                selection[k].armband5 = "无";
              }
              if(selection[k].armband6 == undefined){
                selection[k].armband6 = "无";
              }
            }
            else if(ttt == 1){
              for(var i = 0;i < ttt;i++){
                if(i == 0){
                  if(selection[k].armband1 == undefined){
                    selection[k].armband1 = ddd[i];
                  }
                  if(selection[k].armband2 == undefined){
                    selection[k].armband2 = "无";
                  }
                  if(selection[k].armband3 == undefined){
                    selection[k].armband3 = "无";
                  }
                  if(selection[k].armband4 == undefined){
                    selection[k].armband4 = "无";
                  }
                  if(selection[k].armband5 == undefined){
                    selection[k].armband5 = "无";
                  }
                  if(selection[k].armband6 == undefined){
                    selection[k].armband6 = "无";
                  }
                }
              }
            }
            else if(ttt == 2){
              for(var i = 0;i < ttt;i++){
                if(i == 0){
                  if(selection[k].armband1 == undefined){
                    selection[k].armband1 = ddd[i];
                  }
                  if(selection[k].armband3 == undefined){
                    selection[k].armband3 = "无";
                  }
                  if(selection[k].armband4 == undefined){
                    selection[k].armband4 = "无";
                  }
                  if(selection[k].armband5 == undefined){
                    selection[k].armband5 = "无";
                  }
                  if(selection[k].armband6 == undefined){
                    selection[k].armband6 = "无";
                  }
                }else if(i == 1){
                  if(selection[k].armband2 == undefined){
                    selection[k].armband2 = ddd[i];
                  }
                }
              }
            }
            else if(ttt == 3){
              for(var i = 0;i < ttt;i++){
                if(i == 0){
                  if(selection[k].armband1 == undefined){
                    selection[k].armband1 = ddd[i];
                  }
                  if(selection[k].armband4 == undefined){
                    selection[k].armband4 = "无";
                  }
                  if(selection[k].armband5 == undefined){
                    selection[k].armband5 = "无";
                  }
                  if(selection[k].armband6 == undefined){
                    selection[k].armband6 = "无";
                  }
                }else if(i == 1){
                  if(selection[k].armband2 == undefined){
                    selection[k].armband2 = ddd[i];
                  }
                }else if(i == 2){
                  if(selection[k].armband3 == undefined){
                    selection[k].armband3 = ddd[i];
                  }
                }
              }
            }
            else if(ttt == 4){
              for(var i = 0;i < ttt;i++){
                if(i == 0){
                  if(selection[k].armband1 == undefined){
                    selection[k].armband1 = ddd[i];
                  }
                  if(selection[k].armband5 == undefined){
                    selection[k].armband5 = "无";
                  }
                  if(selection[k].armband6 == undefined){
                    selection[k].armband6 = "无";
                  }
                }else if(i == 1){
                  if(selection[k].armband2 == undefined){
                    selection[k].armband2 = ddd[i];
                  }
                }else if(i == 2){
                  if(selection[k].armband3 == undefined){
                    selection[k].armband3 = ddd[i];
                  }
                }else if(i == 3){
                  if(selection[k].armband4 == undefined){
                    selection[k].armband4 = ddd[i];
                  }
                }
              }
            }
            else if(ttt == 5){
              for(var i = 0;i < ttt;i++){
                if(i == 0){
                  if(selection[k].armband1 == undefined){
                    selection[k].armband1 = ddd[i];
                  }
                  if(selection[k].armband6 == undefined){
                    selection[k].armband6 = "无";
                  }
                }else if(i == 1){
                  if(selection[k].armband2 == undefined){
                    selection[k].armband2 = ddd[i];
                  }
                }else if(i == 2){
                  if(selection[k].armband3 == undefined){
                    selection[k].armband3 = ddd[i];
                  }
                }else if(i == 3){
                  if(selection[k].armband4 == undefined){
                    selection[k].armband4 = ddd[i];
                  }
                }else if(i == 4){
                  if(selection[k].armband5 == undefined){
                    selection[k].armband5 = ddd[i];
                  }
                }
              }
            }
            else if(ttt == 6){
              for(var i = 0;i < ttt;i++){
                if(i == 0){
                  if(selection[k].armband1 == undefined){
                    selection[k].armband1 = ddd[i];
                  }
                }else if(i == 1){
                  if(selection[k].armband2 == undefined){
                    selection[k].armband2 = ddd[i];
                  }
                }else if(i == 2){
                  if(selection[k].armband3 == undefined){
                    selection[k].armband3 = ddd[i];
                  }
                }else if(i == 3){
                  if(selection[k].armband4 == undefined){
                    selection[k].armband4 = ddd[i];
                  }
                }else if(i == 4){
                  if(selection[k].armband5 == undefined){
                    selection[k].armband5 = ddd[i];
                  }
                }else if(i == 5){
                  if(selection[k].armband6 == undefined){
                    selection[k].armband6 = ddd[i];
                  }
                }
              }
            }
          }

          // 整合配件图片
          if(typeof(selection[k].accessories) == 'object'){
            var sss = selection[k].accessories;
            var ggg = selection[k].accessories.length;
            if(ggg == 0){
              if(selection[k].accessories1 == undefined){
                selection[k].accessories1 = '无';
              }
              if(selection[k].accessories2 == undefined){
                selection[k].accessories2 = '无';
              }
            }
            else if(ggg == 1){
              for(var p = 0;p < ggg;p++){
                if(p == 0){
                  if(selection[k].accessories1 == undefined){
                    selection[k].accessories1 = sss[p];
                  }
                  if(selection[k].accessories2 == undefined){
                    selection[k].accessories2 = '无';
                  }
                }
              }
            }
            else if(ggg == 2){
              for(var p = 0;p < ggg;p++){
                if(p == 0){
                  if(selection[k].accessories1 == undefined){
                    selection[k].accessories1 = sss[p];
                  }
                }else if(p == 1){
                  if(selection[k].accessories2 == undefined){
                    selection[k].accessories2 = sss[p];
                  }
                }
              }
            }
          }

        }

        for(let i of this.Data_){
          imageToBase64(i.img).then((response) => 
            {
              // console.log('data:image/jpeg;base64,' + response);
              i.img = 'data:image/jpeg;base64,' + response
            }).catch((error) => 
            {
              console.log(error);
            })
        }

        this.Data_ = selection;
        console.log(this.Data_);

      },
      
      // 店铺筛选
      filter(value, row) {
        return row.site === value;
      },

      // 状态筛选
      filterTag(value, row) {
        return row.status === value;
      },

      // 商品状态筛选
      filterproduct(value, row){
        return row.product_status === value;
      },

      // 物流商筛选
      filterWlS(value, row){
        return row.wls === value;
      },

      //搜索
      search(){
        const search__ = this.$router.resolve({ path: "/home/search_A", query: { id: this.input}});
        window.open(search__.href, '_blank');
      },

      //重置
      reset(){
        this.loading = true;
        this.input = "";
        getProduct().then(res => {
          for(var i = 0;i < res.length;i++){
            if(res[i].armband == '' || res[i].armband == null){
              res[i].armband = "无";
            }
            if(res[i].accessories == '' || res[i].accessories == null){
              res[i].accessories = "无";
            }
            if(res[i].word_no == '' || res[i].word_no == null){
              res[i].word_no = "无";
            }
          }
          this.tableData = res;
          this.loading = false;
        })
      },

      //时间格式化
      utc2timestamp(utc_datetime) {
        // 处理成为时间戳
        var timestamp = new Date(Date.parse(utc_datetime));
        timestamp = timestamp.getTime();
        return timestamp;
      },

      //时间范围筛选
      block(time){
        if(!time){
          this.value1 = [];
        }
        var timestamp,timestamp_ = '';
        timestamp = Date.parse(this.value1[0]);
        timestamp_ = Date.parse(this.value1[1]);
        console.log(timestamp,timestamp_);
        var arr = [];
        getProduct().then(res => {
          for(var i = 0;i < res.length;i++){
            var Time = this.utc2timestamp(res[i].date_paid_gmt);
            console.log(Time);
            if(Time > timestamp && Time < timestamp_){
              arr.push(res[i]);
            }
          }
          this.tableData = arr;
        })
        console.log(arr);
      },
    }
}
</script>

<style lang="scss" scoped>
  .head{
    margin-bottom: 20px;
    .block{
      display: inline-block;
      margin-left: 10px;
    }
  }
  // 隐藏数字输入框后面的上下调节按钮
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield !important;
    appearance: textfield !important;
  }
</style>
<style lang="scss">
  .el-tooltip__popper{
    max-width: 200px !important;
  }
</style>